/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Component imports
import { Form } from 'antd';
import RichTextEditor from '../../../Forms/Fields/RichTextEditor/RichTextEditor';

// Misc imports
import { isJson } from '../../../../utils/is/isJson';
import { useBotLanguage } from '../../../../utils/hooks/useBotLanguage';
import { RICH_TEXT_TOOLBAR_ACTIONS } from '../../../../constants/markdown';

const CustomResponseNodeForm = () => {
  const { t } = useTranslation();
  const { currentBotLanguage, botLanguages } = useBotLanguage();
  const [showConflictMessage, setShowConflictMessage] = useState(false);
  return (
    <Fragment>
      {
        botLanguages.map(lang => (
          <Form.Item
            label="JSON Response"
            hidden={currentBotLanguage !== lang}
            name={['data', 'jsonResponse', lang]}
            rules={[
              {
                validator: (_rule, value) => {
                  // Skip validation if no value provided
                  if (!value) {
                    setShowConflictMessage(false);
                    return Promise.resolve();
                  }

                  const isValidJson = isJson(value);
                  setShowConflictMessage(!isValidJson);

                  return isValidJson ? Promise.resolve() : Promise.reject();
                },
                warningOnly: true,
                message: t('The response is not a valid JSON')
              }
            ]}
            validateStatus={showConflictMessage ? 'warning' : undefined}
          >
            <RichTextEditor
              toolbarActions={[RICH_TEXT_TOOLBAR_ACTIONS.CUSTOM_VARIABLE]}
              placeholder={t('JSON payload')}
              hasFloatingToolbar={true}
              handleAsPlainText={true}
              elementStyles={{ p: { marginBottom: 0 } }}
            />
          </Form.Item>
        ))
      }
    </Fragment>
  );
};

export default CustomResponseNodeForm;
